import Button from '@mui/material/Button';
import styled from 'styled-components';

export const ButtonStyled = styled(Button)`
    height: 44px;
    box-shadow: none;
`;
